import { useState, useEffect } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import Topbar from "./scenes/global/Topbar";
import Sidebar from "./scenes/global/Sidebar";
import Dashboard from "./scenes/dashboard";
import Pumps from "./scenes/Pumps";
import ManagePumps from "./scenes/Pumps/ManagePumps";
import Consumers from "./scenes/Consumers";
import Complaints from "./scenes/complaints";
import ManageConsumers from "./scenes/Consumers/ManageConsumers";
import Contacts from "./scenes/contacts";
import LoginPage from "./scenes/login";
import Form from "./scenes/form";
import Line from "./scenes/line";
//import FAQ from "./scenes/faq";
import PumpConfigUpdate from "./scenes/pumpConfigUpdate";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { ColorModeContext, useMode } from "./theme";
import Calendar from "./scenes/calendar/calendar";
import "bootstrap/dist/css/bootstrap.min.css";
import IndiaPumpMap from "./components/IndiaPumpMap";
import IndividualPump from "./scenes/individualPump/IndividualPump";
import { AuthProvider, useAuth } from "./AuthContext";
import PumpReportGenerator from "./scenes/ReportGenerator/ReportGenerator";
import DashboardUsers from "./scenes/DashboardUsers";
import DemoLogin from "./scenes/demo/DemoLogin";
import DemoLanding from "./scenes/demo/DemoLanding";
import EVChargersPage from "./scenes/demo/EVChargersPage";
import SolarAnalyticsPage from "./scenes/demo/SolarAnalyticsPage";
import BillingPage from "./scenes/demo/BillingPage";
import AssetManagementPage from "./scenes/demo/AssetManagementPage";
import AlertsCenterPage from "./scenes/demo/AlertsCenterPage";
import VoiceAssistant from "./scenes/demo/VoiceAssistant";

// Scrolls to the top of the page on every route change.
const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
};

// Child component to handle routing and auth logic
const MainAppContent = ({ isSidebar, setIsSidebar }) => {
  const { isAuthenticated, clearTokens, userRole } = useAuth();
  const location = useLocation();

  const handleLogout = () => {
    clearTokens();
  };

  // ── Isolated /demo experience (Servotech One) ────────────────────────────
  if (location.pathname.startsWith("/demo")) {
    return (
      <Routes>
        <Route path="/demo/login" element={<DemoLogin />} />
        <Route path="/demo"              element={isAuthenticated ? <DemoLanding />         : <Navigate to="/demo/login" />} />
        <Route path="/demo/ev-chargers"  element={isAuthenticated ? <EVChargersPage />      : <Navigate to="/demo/login" />} />
        <Route path="/demo/solar-analytics" element={isAuthenticated ? <SolarAnalyticsPage /> : <Navigate to="/demo/login" />} />
        <Route path="/demo/billing"      element={isAuthenticated ? <BillingPage />         : <Navigate to="/demo/login" />} />
        <Route path="/demo/assets"       element={isAuthenticated ? <AssetManagementPage /> : <Navigate to="/demo/login" />} />
        <Route path="/demo/alerts"       element={isAuthenticated ? <AlertsCenterPage />    : <Navigate to="/demo/login" />} />
        <Route path="/demo/voice"        element={isAuthenticated ? <VoiceAssistant />      : <Navigate to="/demo/login" />} />
        <Route path="/demo/*"            element={<Navigate to="/demo" />} />
      </Routes>
    );
  }

  return (
    <div className="app">
      {isAuthenticated && <Sidebar isSidebar={isSidebar} />}
      <main className="content">
        <Routes>
          <Route
            path="/"
            element={isAuthenticated ? <Navigate to="/dashboard" /> : <Navigate to="/login" />}
          />
          <Route path="/login" element={<LoginPage />} />
          {isAuthenticated ? (
            <>
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/pumps" element={<Pumps />} />
              <Route path="/managePumps" element={<ManagePumps />} />
              <Route path="/consumers" element={<Consumers />} />
              <Route path="/manageConsumers" element={<ManageConsumers />} />
              <Route path="/complaints" element={<Complaints />} />
              <Route path="/reports" element={<PumpReportGenerator />} />
              <Route path="/individualPump/:imei" element={<IndividualPump />} />
              <Route path="/pumpConfigUpdate" element={<PumpConfigUpdate />} />
              <Route path="/geography" element={<div style={{ height: "100%", width: "100%" }}><IndiaPumpMap /></div>} />
              {userRole === "admin" && (
                <Route path="/dashboardUsers" element={<DashboardUsers />} />
              )}
              <Route path="/contacts" element={<Contacts />} />
              <Route path="/form" element={<Form />} />
              <Route path="/line" element={<Line />} />
              <Route path="/calendar" element={<Calendar />} />
            </>
          ) : (
            <Route path="*" element={<Navigate to="/login" />} />
          )}
        </Routes>
      </main>
    </div>
  );
};

function App() {
  const [theme, colorMode] = useMode();
  const [isSidebar, setIsSidebar] = useState(true);

  return (
    <ColorModeContext.Provider value={colorMode}>
      <AuthProvider>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <ScrollToTop />
          <MainAppContent isSidebar={isSidebar} setIsSidebar={setIsSidebar} />
        </ThemeProvider>
      </AuthProvider>
    </ColorModeContext.Provider>
  );
}

export default App;
